var map = {
	"./test": 6,
	"./test.js": 6
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.id = 5;
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;



/*****************
 ** WEBPACK FOOTER
 ** ./loaders/query/context-query-test ./loaders/query/loaders/queryloader.js?query!^\.\/.*$
 ** module id = 5
 ** module chunks = 0
 **/